import vue from 'vuex'
// 验证邮箱的规则
let checkEmail = (rule, value, cb) => {
  const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
  if (regEmail.test(value) || !value) {
    return cb()
  }
  cb(new Error('请输入合法的邮箱'))
}

// 验证手机号的规则
let checkMobile = (rule, value, cb) => {
  const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
  if (regMobile.test(value) || !value) {
    return cb()
  }
  cb(new Error('请输入合法的手机号'))
}

// 验证邮箱的规则 必填
let checkEmaiNecessaryl = (rule, value, cb) => {
  const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
  if (regEmail.test(value)) {
    return cb()
  }
  cb(new Error('请输入合法的邮箱'))
}

// 验证手机号的规则 必填
let checkMobileNecessary = (rule, value, cb) => {
  const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
  if (regMobile.test(value)) {
    return cb()
  }
  cb(new Error('请输入合法的手机号'))
}

let checkUserName = (rule, value, cb) => {
  const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
  const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
  if (regMobile.test(value) || regEmail.test(value)) {
    return cb()
  } else {
    var localLan = window.localStorage.getItem('translate')
    cb(new Error(localLan === 'zh' ? '请输入合法的手机号或邮箱' : localLan === 'en' ? 'Please enter a valid mobile phone number or email address' : localLan === 'zh-hk' ? '請輸入手機號/郵箱' : ''))
  }

}

export {
  checkEmail,
  checkMobile,
  checkEmaiNecessaryl,
  checkMobileNecessary,
  checkUserName
}